/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./SpangleNotice.scss";

export default function SpangleNotice({ ...restProps }) {
  return (
    <div {...restProps} className={cn("spangle-notice scope-586cb7dc", restProps.className)}>
      <div className="spangle-notice__bulb-icon-wrapper scope-586cb7dc">
        <UseSvg
          className="spangle-notice__bulb-icon scope-586cb7dc"
          icon="bulb"
          data-testid="spangle-notice-bulb-icon"
        />
      </div>
      <div className="spangle-notice__notice-wrapper scope-586cb7dc">
        {" "}
        Upload bold designs with clear colors. <br className="spangle-notice__br scope-586cb7dc" />
        <a
          className="scope-586cb7dc"
          href="#image-upload-tips"
          onClick={e => {
            e.stopPropagation();
          }}
          data-testid="spangle-notice-a"
        >
          View Full Instructions
        </a>
      </div>
    </div>
  );
}
